import { createSelector } from "@reduxjs/toolkit";
import { memoize } from "lodash";

export const getApplicationsForJob = createSelector(
  (state) => state.applications.data || [],
  (applications) => memoize((jobId) => applications.filter((i) => i.jobId.toString() === jobId.toString()))
)